export default "__VITE_ASSET__41099548__"